<template>
  <div class="statical-box-cla">
    <bgChar title="设备总数">{{ dealNumber(50000) }}</bgChar>
    <bgChar title="接口调用数">{{ dealNumber(40000) }}</bgChar>
    <bgChar title="平台应用数">{{ dealNumber(50000) }}</bgChar>
    <bgChar title="平台开发数">{{ dealNumber(40000) }}</bgChar>
  </div>
</template>

<script>
import bgChar from './bgChar'
import { dealNumber } from '@/utils/utils.js'
export default {
  data() {
    return {}
  },
  components: {
    bgChar
  },
  mounted() {
  },
  methods: {
    dealNumber(number) {
      return dealNumber(number)
    }
  }
}
</script>

<style scoped lang="less">
.statical-box-cla {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/statistical/statistical.vue